import InputFileUpload from "../components/InputFileUpload";
import {useContext, useEffect, useState} from "react";
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import {getFile, deleteFile} from "../http/fileApi.js";
import RuleChooser from "../components/rule/RuleChooser";
import Button from "@mui/material/Button";
import ContractChooser from "../components/contract/ContractChooser";
import {useNavigate, useParams} from "react-router-dom";
import {LOGIN_ROUTE, UPLOAD_ROUTE} from "../utils/constants";
import PeriodChooser from "../components/PeriodChooser";
import {jwtDecode} from "jwt-decode";
import * as React from "react";
import {getReportData} from "../http/reportApi";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {DataGrid} from "@mui/x-data-grid";

const File = observer(() => {
    const navigate = useNavigate();
    let {file} = useParams();


    const [data, setData] = React.useState([]);
    console.log(data);

    const getInfo = async () => {
        try {
            const response = await getFile(file);
            setData(response);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                // user.setIsAuth(false);
                return navigate(LOGIN_ROUTE);
            }
        }
    };

    useEffect(() => {
        (async () => {
            await getInfo();
        })();
    }, [file]);

    const rowClick = async () => {

    }

    let columns = [];
    columns.push({
        field: "id",
        headerName: "id",
        width: 120,
        editable: false,
        sortable: false,
    });
    columns.push({
        field: "period",
        headerName: "Период",
        width: 120,
        editable: false,
        sortable: false,
    });
    columns.push({
        field: "singer",
        headerName: "Артист",
        width: 270,
        editable: false,
        sortable: true,
    });
    columns.push({
        field: "songName",
        headerName: "Трек",
        width: 270,
        editable: false,
        sortable: true,
    });
    columns.push({
        field: "album",
        headerName: "Релиз",
        width: 270,
        editable: false,
        sortable: true,
    });
    columns.push({
        field: "platform",
        headerName: "Платформа",
        width: 340,
        editable: false,
        sortable: true,
    });
    columns.push({
        field: "authorLicensePrize",
        headerName: "Авторское вознаграждение",
        width: 340,
        editable: false,
        sortable: true,
    });
    columns.push({
        field: "relatedLicensePrize",
        headerName: "Смежное вознаграждение",
        width: 340,
        editable: false,
        sortable: true,
    });


    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                justifyContent="space-between"
                width={'100%'}
                p={4}
                paddingBottom={0}
            >
                <Box>
                    <Typography variant="h2">
                        {data[0]?.fileName}
                    </Typography>
                </Box>
                {data && data.length ?
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={async () => {
                        if(window.confirm("Удалить этот файл?")){
                            await deleteFile(file);
                            navigate(UPLOAD_ROUTE);
                        }
                    }}
                >Удалить файл</Button> : null}
            </Box>
            <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                justifyContent="space-between"
                width={'100%'}
                p={4}
                paddingTop={1}
            >
                <Box>
                    <Typography variant="h5" gutterBottom>
                        {data && data.length ? new Date(data[0]?.createdAt).toLocaleString() : ""}
                    </Typography>
                </Box>
            </Box>
            {data && columns && (
                <Box sx={{height: "100%", width: "100%"}}>
                    <DataGrid
                        rows={data}
                        columns={columns}
                        autosizeOptions={{
                            // columns: ['fileName', 'period', 'summary', 'authorTotal', 'relatedTotal'],
                            includeOutliers: true,
                            includeHeaders: true,
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 100,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        disableRowSelectionOnClick
                        onRowClick={rowClick}
                    />
                </Box>
            )}
        </div>
    );
});

export default File;
